<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="search-input-wrapper">
    <input
      v-model="userinput"
      class="search-input"
      type="text"
      :placeholder="$t('search_placeholder')"
      @keyup.enter="searchHandler(userinput)"
    >
    <div class="border-background" />
    <div class="search-input-icon-left" @click="searchHandler(userinput)" />
    <div v-if="userinput !== ''" class="search-input-icon-right" @click="resetSearch()" />
  </div>
</template>

<script>
/**
 * Custom input with icons to type a word for search
 * @example [none]
 */
export default {
  props: {
    takeParams: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      userinput: this.takeParams && this.$route ? (this.$route.params.params ? this.$route.params.params : '') : '',
    }
  },
  watch: {
    $route() {
      if (this.takeParams && this.$route && this.$route.params && this.$route.params.params) {
        this.userinput = this.$route.params.params
      }
    }
  },
  mounted() {
    if (document.getElementById('search-input')) document.getElementById('search-input').focus()
  },
  methods: {
    /**
     * Emits an event to know when the user search a new value with Search button click or pressing enter keyboard key
     * @public This is a public method
     * @param {String} value search string value
     */
    searchHandler: function (value) {
      /** Triggers and event to show loading
       * @event toggle-data-loading
       */
      this.$emit('toggle-data-loading')
      /** Triggers when the user search a value
       * @event search-pressed
       * @property {String} value new value searched
       */
      this.$emit('search-pressed', value)
    },
    /**
     * Sets the input user search value to empty string
     * @public This is a public method
     */
    resetSearch: function () {
      this.userinput = ''
      if (this.$route.params?.params) {
        let updatedQuery = { ...this.$route.query }
        delete updatedQuery.page
        let params = {}
        if (this.$route.params.optype) {
          params = {
            lang: this.$route.params.lang,
            optype: this.$route.params.optype
          }
        } else {
          params = {
            lang: this.$route.params.lang,
          }
        }
        this.$router.push({
          name: this.$route.name,
          params: params,
          query: updatedQuery,
        })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.search-input-wrapper
  position: relative

  &.small
    &.warning,
    &.success
      &:after
        width: vw(18px)
        height: vw(18px)

    .search-input
      m-font-size(14, 18)
      height: vw(32px)

    .search-input-icon-left,
    .search-input-icon-right
      width: vw(18px)
      height: vw(18px)

  &.warning
    &:after
      m-icon("warning", 24, $warning)
      position: absolute
      top: 50%
      right: vw(12px)
      z-index: 1
      content: ""
      transform: translateY(-50%)

    .search-input
      border-color: $warning

  &.success
    &:after
      m-icon("success", 24, $success)
      position: absolute
      top: 50%
      right: vw(12px)
      z-index: 1
      content: ""
      transform: translateY(-50%)

    .search-input
      border-color: $success

  &.disabled
    pointer-events: none

    .search-input
      border-color: $very-light-grey
      background-color: $very-light-grey
      color: $grey-grey
      font-weight: 400

      &::placeholder
        color: $grey-grey

    .search-input-icon-left,
    .search-input-icon-right
      background-color: $grey-grey

.search-input
  m-font-size(16, 20)
  position: relative
  padding: 0
  padding-right: vw(44px)
  padding-left: vw(44px)
  width: 100%
  height: vw(48px)
  outline: none
  border: 1px solid $grey-accessibility
  border-radius: 4px
  background-color: $light-grey
  color: #000
  font-weight: 600

  &::placeholder
    color: $grey
    font-weight: 400

  &:focus
    position: relative
    z-index: 1
    border-color: $black
    background-color: #fff

    + .border-background
      position: absolute
      top: vw(-4px)
      left: vw(-4px)
      width: "calc(100% + %s)" % vw(8px)
      height: "calc(100% + %s)" % vw(8px)
      border-radius: 4px
      background-color: $grey-grey

    ~ .search-input-icon-left
      z-index: 1

    ~ .search-input-icon-right
      z-index: 1

.search-input-icon-left
  m-icon("search", 24, $grey-dark)
  position: absolute
  top: 50%
  left: vw(12px)
  width: vw(24px)
  height: vw(24px)
  cursor: pointer
  transform: translateY(-50%)

.search-input-icon-right
  m-icon("close", 24, $grey-dark)
  position: absolute
  top: 50%
  right: vw(12px)
  cursor: pointer
  transform: translateY(-50%)
</style>
